import { useSelector } from 'react-redux';

function useToken(): string {
  // @ts-ignore
  return useSelector((state) => state.user.token);
}
export default useToken;
